// Force layout calc (see https://gist.github.com/paulirish/5d52fb081b3570c81e3a)
function forceLayoutCalc(element) {
	return void element?.clientHeight;
}

export default forceLayoutCalc;
